
import { AxiosResponse } from 'axios';
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IServicePayload, IDeleteDataResponseAndPayload, IServiceList } from "../../../types/api/service";


export async function saveService(data: IServicePayload): Promise<AxiosResponse<TResponse<IServicePayload>>> {
    return axios.post<TResponse<IServicePayload>>(API_ENDPOINTS.SERVICE_SAVE, data)
}

export async function listService(qData: QData): Promise<AxiosResponse<TResponseWithQData<IServiceList[]>>> {
    return axios.get(API_ENDPOINTS.SERVICE_LIST, {
        params: qData
    })
}

export async function deleteService(data: IDeleteDataResponseAndPayload): Promise<AxiosResponse<TResponse<IDeleteDataResponseAndPayload>>> {
    return axios.post<TResponse<IDeleteDataResponseAndPayload>>(API_ENDPOINTS.SERVICE_DELETE, data)
}

export async function serviceDetail(
  slug: string
): Promise<AxiosResponse<TResponse<IServicePayload>>> {
  return axios.get(`${API_ENDPOINTS.SERVICE_DETAIL}/${slug}`);
}